import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {AppService} from '../../../app-common/services/app/app.service';
import {Router} from '@angular/router';
import {PermissionService} from '../../../permission/services/permission/permission.service';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';
import {ColorService} from '../../../app-common/services/color/color.service';
import {HttpClient} from '@angular/common/http';
import {TenantService} from '../../services/tenant/tenant.service';
import {ElectronService} from 'ngx-electron';
import {environment} from '../../../../environments/environment';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {ProblemDetails} from '../../../app-common/data/problemDetails';
import {LoginRequest} from '../../data/loginRequest';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss', '../unauthorized.scss']
})
export class LoginPageComponent implements OnInit {
  username: string;
  password: string;
  problemDetails: ProblemDetails<LoginRequest>;

  constructor(public appService: AppService,
              public authService: AuthService,
              public colorService: ColorService,
              public appStateService: AppStateService,
              public permissionService: PermissionService,
              public router: Router,
              public httpClient: HttpClient,
              private electronService: ElectronService,
              private tenantService: TenantService,
              private loggerService: LoggerService) {
    this.appService = appService;
    this.authService = authService;
    this.colorService = colorService;
    this.appStateService = appStateService;
    this.permissionService = permissionService;
    this.router = router;
  }

  async ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.router.navigate(['tenant']);
    }
  }

  async loginButtonAction() {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.LoginPage, 'Clicked login button');
    const response = await this.authService.login(this.username, this.password).then(() => {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.LoginPage, 'Login successful, navigating to tenant page');
      this.router.navigate(['tenant']);
    }).catch(error => {
      if (error instanceof ProblemDetails) {
        this.problemDetails = error;
      }
    });
  }

  openForgotPasswordLink() {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.LoginPage, 'Clicked forgot password link');
    if (this.electronService.isElectronApp) {
      this.electronService.ipcRenderer.send('open-link', {url: environment.authFrontendUrl + '/forgotPassword'});
    }
    else {
      window.open(environment.authFrontendUrl + '/forgotPassword', '_blank');
    }
  }

  changeStateToRegister() {
    this.appStateService.appWindowState = AppWindowState.Register;
  }

  changeStateToForgotPassword() {
    this.appStateService.appWindowState = AppWindowState.ForgotPassword;
  }
}
